import { TAccount } from './accounts.types';

/**
 * Determines if an account is a merchant_cash_advance product type
 * @param account: TAccount- An Account object
 * @returns true or false
 */
export const getAccountIsRBL = (account: TAccount): boolean => {
    return Boolean(account.product_type === 'merchant_cash_advance');
};
